export default "__VITE_PUBLIC_ASSET__c07c69ed__"